import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./taxActions";
import {userLogoutReceived} from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: '',
  taxes: [],
});

//is action payload immutable?
export const taxReducer = handleActions(
  {
    [combineActions(Actions.configureTaxRequested, Actions.fetchTaxesRequested, Actions.deleteTaxRequested)](state, action) {
      return state
        .set("isFetchingData", true)
        .set("error", '')
    },
    [combineActions(Actions.fetchTaxesFailed, Actions.deleteTaxFailed, Actions.configureTaxFailed)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", action.payload)
    },
    [combineActions(Actions.configureTaxReceived, Actions.deleteTaxReceived)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", '')
    },
    [Actions.fetchTaxesReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("taxes", Immutable.fromJS(action.payload))
        .set("error", '')
    },
    [Actions.unSetTaxError](state, action) {
      return state
        .set("error", '')
    },
    [userLogoutReceived](state, action) {
      return initialState
    }
  },
  initialState
);


// WEBPACK FOOTER //
// ./src/features/tax/store/taxReducer.js